import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import { BackArrowIcon } from "../../../Assets/Icons";
import { useNavigate, useParams } from "react-router-dom";
import CreateGroup from "./CreateGroup";
import CreateUser from "./CreateUser";
import apiClient from "../../../apiClient";
import { GET_CHANNEL_DETAIL, GET_CHANNEL_LIST, UPDATE_CHANNEL_DETAIL, CATEGORY_TAGS_LIST } from "../../../apiClient/apiEndpoints";
import { categoryIds, SSO_URL } from "../../../env";
import { debounce } from "../../../Utils/general";

const { BackButton } = UiComponents;

const EditOrganization = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [channelList, setChannelList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState({ user: null, group: null });
  const [groupDetails, setGroupDetails] = useState({
    logo: null,
    name: "",
    website: null,
    channel: null,
    identifier: null,
    industry: [],
    address: {
      address1: null,
      address2: null,
      city: "",
      state: null,
      country: null,
      pincode: null,
    },
  });
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    uid: "",
    phone: null,
    designation: null,
    password: "",
  });


  const backClick = () => navigate(-1);

  const resetToInitialDetails = () => {
    if (initialData.user && initialData.group) {
      setUserDetails(initialData.user);
      setGroupDetails(initialData.group);
    }
    setError(null);
  };

  const getChannelDetail = async () => {
    try {
      const response = await apiClient(`${SSO_URL}${GET_CHANNEL_DETAIL}/${id}`);
      if (!response) return;

      const { data, parent, name, tags } = response;

      const userData = {
        name: data?.user?.name || "",
        email: data?.user?.email || "",
        uid: data?.user?.uid || "",
        phone: data?.user?.phone || "",
        designation: data?.user?.designation || "",
        password: "",
      };

      const groupData = {
        name: name || "",
        website: data?.website || "",
        channel: data?.channel?.uuid || null,
        identifier: data?.identifier || "",
        industry: tags.map(e => ({label:e.name, value: e.id })),
        address: {
          address1: data?.address?.address1 || "",
          address2: data?.address?.address2 || "",
          city: data?.address?.city || "",
          state: data?.address?.state || "",
          country: data?.address?.country || "",
          pincode: data?.address?.pincode || "",
        },
      };

      setUserDetails(userData);
      setGroupDetails(groupData);
      setInitialData({ user: userData || {}, group: groupData });
    } catch (error) {
      console.error("Error fetching channel details:", error.message);
    }
  };
  const getChannelList = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${GET_CHANNEL_LIST}`);
      let list = data.map((e) => ({ value: e.uuid, label: e.name, type: e.type }));
      setChannelList(list);
    } catch (error) {
      console.log(error);
    }
  };
  const getTagsList = async() =>{
    try {
      let data = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/${categoryIds["INDUSTRIES"]}`);
      setTagsList(data.map(e => ({value:e.id, label:e.name})))
  } catch (error) {
      console.log(error);
  }
  };

  useEffect(() => {
    getChannelDetail();
    getTagsList();
    getChannelList();
  }, []);

  const validateDetails = () => {
    let errorStatus = false;
     
    const raiseError = (message) => {
      setError(message);
      errorStatus = true;
    };

    const groupRequiredFields = [
      { condition: !groupDetails.name.trim(), message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.channel, message: "Kindly fill all (*) fields." },
      { condition: groupDetails.industry.length === 0, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.country, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.state, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.city.trim(), message: "Kindly fill all (*) fields." }
    ];

    for (const field of groupRequiredFields) {
      if (field.condition) {
        raiseError(field.message);
        return true;
      }
    }


    return errorStatus;
  };

  const handleEditOrganization = async () => {
    if(loading) return;
    if (validateDetails()) return;

    try {
      setLoading(true);

      const bodyData = {
        group: {
          name: groupDetails.name.trim(),
          identifier: groupDetails.identifier,
          address: groupDetails.address,
          website: groupDetails.website,
          industryIds: groupDetails.industry.map(e => e.value),
        },
        // user: {
        //   name: userDetails.name,
        //   email: userDetails.email || null,
        //   designation: userDetails.designation,
        //   phone: userDetails.phone,
        // },
      };

      await apiClient.post(`${SSO_URL}${UPDATE_CHANNEL_DETAIL}/${id}`, bodyData);
      await getChannelDetail();
    } catch (error) {
      console.error("Update failed:", error);
      setError("Failed to update organization. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDebounceCreate = debounce(handleEditOrganization, 500);

  return (
    <div className="org-creation">
      <div className="page-title" style={{ border: "none" }}>
        <div className="title-back">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h6>Edit Organization</h6>
        </div>
      </div>

      <div className="sim-section-wrapper">
        <div className="sim-section">
          <div className="input-section-wrapper">
            <CreateGroup
              loading={loading}
              error={error}
              groupDetails={groupDetails}
              setGroupDetails={setGroupDetails}
              channelList={channelList}
              tagsList={tagsList}
              handleCancelClicked={resetToInitialDetails}
              handleDebounceCreate={handleDebounceCreate}
              disable={true}
            />
          </div>

          <div className="input-section-wrapper">
            <CreateUser
              userDetails={userDetails}
              setUserDetails={setUserDetails}
              disable={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrganization;
